<script>

    import { createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher()

    export let value = null
    export let placeholder = 'Buscar'

</script>

<div class="field has-addons">
    <div class="control is-expanded">
        <input
            bind:value={value}
            on:keyup={e => e.code === 'Enter' && dispatch('enter')}
            class="input"
            type="text"
            placeholder={placeholder}
            required={false}
            autocomplete="off"
        />
    </div>
    <div class="control">
        <button
            type="button"
            class="button"
            on:click={() => dispatch('enter')}
        >
            Buscar
        </button>
    </div>
</div>
